import React, { useEffect, useState } from 'react';
import { message } from 'antd';

import { FormView } from './FormView';
import { useClient } from 'src/contexts';

import { ApiPublicationResponseType, ApiPublicationType } from '../../types';

type ReadPollProps = {
  id: string;
};

export const ReadPollForm: React.FC<ReadPollProps> = ({ id }) => {
  const { get } = useClient();
  const [loading, setLoading] = useState(false);
  const [poll, setPoll] = useState<ApiPublicationType | undefined>();

  useEffect(
    () => {
      if (!id && !loading) return;

      setLoading(true);

      get(
        `/polls/${id}`,
        (response: ApiPublicationResponseType) => {
          if (!response.data) return;

          setPoll(response.data);
          setLoading(false);
        },
        () => {
          message.error(
            'Une erreur est survenu lors de la récupération de la publication'
          );
          setLoading(false);
        }
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]
  );

  return poll ? (
    <FormView poll={poll} loading={loading} disableForm={true}></FormView>
  ) : null;
};
